// sla-compliance-stat.tsx — SLA compliance stat card with on-time percentage.
import { Card, CardBody, CardTitle, Skeleton } from '@vnetwork/ui/primitives';
import { Stat, StatGroup } from '@vnetwork/ui/data';
import { Alert } from '@vnetwork/ui/feedback';
import type { SLACompliance } from '@/api/tickets-statistics';

interface Props {
  data: SLACompliance | undefined;
  isLoading: boolean;
  isError: boolean;
}

export function SLAComplianceStat({ data, isLoading, isError }: Props) {
  const pct = data?.ontime_percentage ?? 0;
  const dotColor =
    pct >= 90
      ? 'var(--vn-success-solid)'
      : pct >= 70
        ? 'var(--vn-warning-solid)'
        : 'var(--vn-danger-solid)';

  return (
    <Card flat>
      <CardBody>
        <CardTitle style={{ marginBottom: 'var(--vn-space-3)' }}>SLA Compliance</CardTitle>
        {isError ? (
          <Alert tone="danger" title="Failed to load SLA data" />
        ) : isLoading ? (
          <Skeleton style={{ height: 80 }} />
        ) : (
          <StatGroup columns={4}>
            <Stat
              label="On-time Rate"
              value={`${Number(pct).toFixed(1)}%`}
              dotColor={dotColor}
            />
            <Stat
              label="Total"
              value={(data?.total_tickets ?? 0).toLocaleString('en-US')}
            />
            <Stat
              label="On-time"
              value={(data?.ontime_count ?? 0).toLocaleString('en-US')}
              dotColor="var(--vn-success-solid)"
            />
            <Stat
              label="Late"
              value={(data?.late_count ?? 0).toLocaleString('en-US')}
              dotColor="var(--vn-danger-solid)"
            />
          </StatGroup>
        )}
      </CardBody>
    </Card>
  );
}
